import "./button.css";
import React from "react";
import {
  Button as CButton,
  ButtonProps as CButtonProps,
  useColorMode,
} from "@chakra-ui/react";

export interface ButtonProps {
  /**
   * Is this the principal call to action on the page?
   */
  variant?: "solid" | "outline" | "ghost" | "link";
  /**
   * What background color to use
   */
  colorScheme?: string;
  /**
   * How large should the button be?
   */
  size?: "xs" | "sm" | "md" | "lg";
  /**
   * Button contents
   */
  label: string;
  /**
   * Optional click handler
   */
  onClick?: () => void;

  disabled?: boolean;
}

/**
 * Primary UI component for user interaction
 */
export const Button = ({
  variant = "solid",
  size = "md",
  colorScheme = "myScheme",
  label,
  disabled = false,
  onClick,
  ...props
}: ButtonProps) => {
  return (
    <CButton
      colorScheme={colorScheme}
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {label}
    </CButton>
  );
};

export const ButtonWrapper = ({ ...props }: CButtonProps) => {
  const { colorMode } = useColorMode();
  const getColor = () => {
    return colorMode === "light"
      ? {
          bg: "#FFFFFF",
          color: "#000000",
        }
      : {
          bg: "#2B2B2B",
          color: "#FFFFFF",
        };
  };
  return (
    <CButton
      backgroundColor={getColor().bg}
      color={getColor().color}
      {...props}
    >
      {props.children}
    </CButton>
  );
};
